import React, { useEffect, useState } from 'react';
import { toInteger } from 'lodash';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent,
  colors,
  Grid
} from '@material-ui/core';

import Page from 'src/components/Page';
import api from '../../../services/api';

import Alerts from '../../../utils/alerts';
import Confirmations from '../../../utils/confirmations';


import Results from '../Results';
import Toolbar from './Toolbar';

import Activity from '../../equipments/Activity';
import Usage from '../../equipments/Usage';
import Treatment from '../Treatment';
import Latest from '../Latest';
import Situation from '../Situation';



import History from '@material-ui/icons/History';
import SolvingIcon from '@material-ui/icons/DirectionsRun';
import NewsIcon from '@material-ui/icons/NotificationsActive';
import SolvedIcon from '@material-ui/icons/NotificationsOff';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const NEW = { id: 0, name: 'Novo', icon: NewsIcon, color: colors.red[600] }
const SOLVING = { id: 1, name: 'Em Tratamento', icon: SolvingIcon, color: colors.yellow[500] }
const RESOLVED = { id: 2, name: 'Resolvido', icon: SolvedIcon, color: colors.green[600] }
const CLOSED = { id: 3, name: 'Fechado', icon: SolvedIcon, color: colors.blue[400] }

const alarmStatusList = [NEW, SOLVING, RESOLVED, CLOSED];

const defaultTreatment = {
  detail: null,
  action: null,
  alarm: { fails: [] },
  user: localStorage.getItem('userid'),
  occurrence: null,
  status: {},
  equipment: {},
  location: {}
}

const defaultItem = {
  register: null,
  status: null,
  description: null,
  detail: null,
  device: null,
  occurrence: null,
  event: null,
  company: null,
  fails: []
}

const defaultDependencies = {
  loaded: false,
  news: 0,
  resolveds: 0,
  solving: 0,
  total: 0,
  statuslist: alarmStatusList,
  activations: [],
  actions: [],
  treatments: [],
  distribution: {}
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultUsageItem = {
  loaded: false,
  event: {},
  alarm: {},
  device: {},
  schedules: [],
  commands: {},
  panel: { instruments: [] },
  message: { inputs: [] }
};

const defaultGraphicData = {
  loaded: false,
  labels: [],
  datasets: []
};

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Alarme', field: 'formatNumber(item.register, "000000")', size: 50, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Status', field: 'statusValueName(dependencies, item.status)', size: 100, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Data', field: 'formatDatetime(item.createdAt)', size: 100, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Local', field: 'locationValueName(dependencies, item)', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Equipamento', field: 'equipmentValueName(dependencies, item)', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Falha', field: 'failValueName(dependencies, item)', size: -1, sortable: null, exportable: 0, wrap: 0 },
];

const defaultEmptyMessage = "Nenhum Alarme Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_HIDE,
  update: LEVEL_ACCESS_HIDE,
  delete: LEVEL_ACCESS_HIDE,
  config: LEVEL_ACCESS_ENABLED,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_HIDE,
  update: LEVEL_ACCESS_HIDE,
  delete: LEVEL_ACCESS_HIDE,
  config: LEVEL_ACCESS_ENABLED,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Alarmes pela Data de Criação', refine: 2, label: 'Alarme', history: 0 }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0],
  status: [0, 1, 2]
}


const getDistribution = (alarms, days) => {
  var dates = Array(days);
  var newscount = Array(days);
  var solvingcount = Array(days);
  var resolvedscount = Array(days);
  for (var day = (days - 1); day >= 0; day--) {
    var index = (days - day - 1);
    var current = moment().subtract(day, 'day');
    dates[index] = current.format("DD/MM");
    newscount[index] = 0;
    solvingcount[index] = 0;
    resolvedscount[index] = 0;
    alarms.map(alarm => {
      if (moment(alarm.date).format('DD/MM/YYYY') === current.format('DD/MM/YYYY')) {
        if (alarm.status.id === NEW.id) {
          newscount[index]++;
        }

        if (alarm.status.id === SOLVING.id) {
          solvingcount[index]++;
        }

        if (alarm.status.id === RESOLVED.id) {
          resolvedscount[index]++;
        }
      }
    });

  }
  var value = ({
    news: newscount,
    solving: solvingcount,
    resolveds: resolvedscount,
    dates: dates
  })
  return value;
}

const Dashboard = () => {

  const classes = useStyles();

  const [companyId, setCompanyId] = useState(localStorage.getItem('companyid'));

  const [graphicData, setGraphicData] = useState(defaultGraphicData);
  const [startDateTime, setStartDateTime] = useState(new Date());
  const [endDateTime, setEndDateTime] = useState(new Date());
  const [field, setField] = useState({});

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);

  const [state, setState] = useState(defaultState);
  const [usageItem, setUsageItem] = useState(defaultUsageItem);
  const [openUsageDialog, setOpenUsageDialog] = useState(false);
  const [openActivityDialog, setOpenActivityDialog] = useState(false);
  const [treatment, setTreatment] = useState(defaultTreatment);

  const [rangeDays, setRangeDays] = useState(7);

  const getEquipment = (device, activations) => {
    var eqp = {};
    activations.forEach(activation => {
      if (activation.device == device) {
        eqp = activation.equipment;
      }
    });
    return (eqp._id) ? eqp : { name: 'Descrição do Dispositivo ' + device, description: 'não foi Encontrada' }
  }
  const getLocation = (device, activations) => {
    var loc = {}
    activations.forEach(activation => {
      if (activation.device == device) {
        loc = activation.location;
      }
    });
    return (loc._id) ? loc : { name: device, plan: 'Localização do Dispositivo ', address: 'não foi Encontrada', neighborhood: '', city: '' }
  }

  const openExportDialog = async (format) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const openEdition = async (item) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const openCreation = (item) => {
    setItem(item);
    setOpenEditionDialog(true);
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Alarme',
      message: 'Deseja excluir o alarme selecionado?',
      warn: 'Esta ação irá interferir no relatório de alarmes do equipamento.',
      details: ['Não será possível recuperar o alarme excluido.']
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = (item) => {
    api.post('/treatments/alarm', { alarm: item._id, state: item.status }, {}).then(async (response) => {
      if (!response.data.error) {
        setDependencies({
          actions: response.data.actions,
          treatments: response.data.treatments,
          ...dependencies
        });
        setTreatment({
          detail: '',
          action: null,
          alarm: item,
          user: localStorage.getItem('userid'),
          occurrence: item.occurrence,
          status: alarmStatusList[item.status],
          equipment: getEquipment(item.device, dependencies.activations),
          location: getLocation(item.device, dependencies.activations)
        });
        setItem(item);
        setOpenTreatmentDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    })
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    values.company = companyId;
    api.post('/treatments', values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeTreatment();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao criar tratamento.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const updateValues = (values) => {
    setItem(values);
    refreshItems();
  };

  const createValues = (values) => {
    setItem(values);
    refreshItems();
  };

  const updateDependencies = async (values) => {

  };

  const deleteValues = (values) => {
    api.delete('/alarms/' + values._id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao remover alarme.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    api.post('/alarms/history', { filtro: value, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
        var alarms = response.data.rows;
        setDependencies({
          loaded: true,
          news: getStatusCount(alarms, NEW),
          resolveds: getStatusCount(alarms, SOLVING),
          solving: getStatusCount(alarms, RESOLVED),
          total: response.data.count,
          statuslist: alarmStatusList,
          activations: response.data.activations,
          distribution: getDistribution(alarms, rangeDays)
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de equipamentos.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision
    };
    setVision(vision);
    setFilter(value);
    api.post('/alarms/history', { filtro: value, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
        var alarms = response.data.rows;
        setDependencies({
          loaded: true,
          news: getStatusCount(alarms, NEW),
          resolveds: getStatusCount(alarms, SOLVING),
          solving: getStatusCount(alarms, RESOLVED),
          total: response.data.count,
          statuslist: alarmStatusList,
          activations: response.data.activations,
          distribution: getDistribution(alarms, rangeDays)
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de equipamentos.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const refreshItems = () => {
    api.post('/alarms/history', { filtro: filter, company: companyId }, {}).then(async (response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / filter.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : filter.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
        var alarms = response.data.rows;
        setDependencies({
          loaded: true,
          news: getStatusCount(alarms, NEW),
          resolveds: getStatusCount(alarms, SOLVING),
          solving: getStatusCount(alarms, RESOLVED),
          total: response.data.count,
          statuslist: alarmStatusList,
          activations: response.data.activations,
          distribution: getDistribution(alarms, rangeDays)
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de alarmes.', detail: error.message });
      setOpenAlert(true);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }

    const newEvent = (event) => {
      if (openUsageDialog || openActivityDialog) {
        new Promise(updateUsageItem).then((value) => {
          setUsageItem(value);
          if (openActivityDialog) {
            changeGraphic(field, startDateTime, endDateTime);
          }
        })
      }
    }

    const newAlarm = (alarm) => {
      refreshItems();
    }

    const newTreatment = (treatment) => {
      refreshItems();
    }
  }, []);

  const sendCommands = (commands, index, value) => {
    var vlr = 1;
    if (value === vlr) vlr = 0;
    commands.values[index] = vlr;
    api.put('/commands/' + commands._id, commands).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  }

  const changeGraphic = (field, sdt, edt) => {
    setField(field);
    setStartDateTime(sdt);
    setEndDateTime(edt);
    api.post('/events/activity', {
      filter: {
        device: localStorage.getItem('deviceid'),
        message: usageItem.message.code,
        sample: 200,
        startDateTime: sdt,
        endDateTime: edt
      }
    }, {
    }).then((response) => {
      if (!response.data.error) {
        var events = response.data;
        var data = {
          loaded: true,
          labels: [],
          datasets: []
        }

        if (field) {
          data.datasets.push(
            {
              label: 'Valor de ' + field.name + ' em ' + field.unit,
              fill: false,
              lineTension: 0.1,
              backgroundColor: 'rgba(75,152,255,0.5)',
              borderColor: 'rgba(75,152,255,0.5)',
              borderWidth: 1,
              data: []
            });

          field.tests.map((tst, tsti) => {
            data.datasets.push(
              {
                label: tst.description,
                fill: false,
                lineTension: 0.0,
                backgroundColor: (tst.rule && tst.rule.event && tst.rule.event.type && tst.rule.event.type == 'fail') ? 'rgba(255,0,0,0.5)' : 'rgba(255,255,0,0.5)',
                borderColor: (tst.rule && tst.rule.event && tst.rule.event.type && tst.rule.event.type == 'fail') ? 'rgba(255,0,0,0.5)' : 'rgba(255,255,0,0.5)',
                borderWidth: 1,
                pointRadius: 0,
                pointHitRadius: 0,
                data: []
              });
          });

          events.map((evt, evti) => {
            data.labels.push(moment(evt.createdAt).format('DD/MM HH:mm:ss'));
            var value = numeral(evt.data[field.order]).format(field.format);
            data.datasets[0].data.push(value);
            field.tests.map((tst, tsti) => {
              if (tst.rule && tst.rule.conditions && tst.rule.conditions.all && tst.rule.conditions.all.length > 0) {
                var level = tst.rule.conditions.all[tst.rule.conditions.all.length - 1].value
                data.datasets[tsti + 1].data.push(level);
              }
            });
          });
        }
        setGraphicData(data);
      }
    })
  }

  const openActivity = (item) => {
    setOpenActivityDialog(true);
  }

  const closeActivity = () => {
    setOpenActivityDialog(false);
  }

  const openUsage = (item) => {
    localStorage.setItem('deviceid', item.device);
    new Promise(updateUsageItem).then((value) => {
      setUsageItem(value)
      setOpenUsageDialog(true);
    }).catch((error) => {
      setMessage(error);
      setOpenAlert(true);
    })
  }

  const closeUsage = () => {
    setOpenUsageDialog(false);
  }

  const updateUsageItem = (resolve, reject) => {
    var deviceId = localStorage.getItem('deviceid');
    api.post('/events/device', { company: companyId, device: deviceId }, {
    }).then((response) => {
      var usageItem = defaultUsageItem;
      if (!response.data.error) {
        usageItem = {
          loaded: true,
          device: response.data.device,
          activation: response.data.activation,
          message: response.data.message,
          event: response.data.event,
          panel: response.data.panel,
          alarm: response.data.alarm,
          schedules: response.data.schedules,
          commands: response.data.commands
        };
        resolve(usageItem)
      } else {
        reject(response.data)
      }
    })
  }

  const getStatusCount = (alarms, status) => {
    var count = 0;
    alarms.map((alarm) => {
      if (alarm.status === status.id) {
        count++;
      }
      return alarm;
    });
    return count;
  }

  return (
    <Page
      className={classes.root}
      title="Relatório"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={History}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
          dependencies={dependencies}
        />

        <Activity open={openActivityDialog}
          equipment={item}
          usageItem={usageItem}
          closeActivity={closeActivity}
          changeGraphic={changeGraphic}
          graphicData={graphicData}
          field={field}
        />

        <Usage
          open={openUsageDialog}
          usageItem={usageItem}
          closeUsage={closeUsage}
          openAcitivity={openActivity}
          sendCommands={sendCommands} />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Treatment item={treatment}
          openEdition={openTreatment}
          closeEdition={closeTreatment}
          updateValues={updateTreatmentValues}
          open={openTreatmentDialog}
          dependencies={dependencies}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  lg={8}
                  md={12}
                  xl={9}
                  xs={12}
                >
                  <Latest distribution={dependencies.distribution} />
                </Grid>
                <Grid
                  item
                  lg={4}
                  md={6}
                  xl={3}
                  xs={12}
                >
                  <Situation
                    news={dependencies.distribution.news}
                    solving={dependencies.distribution.solving}
                    resolveds={dependencies.distribution.resolveds}
                    total={dependencies.distribution.total} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>

      </Container>
    </Page>
  );
};

export default Dashboard;
